<template>
    <div class="content">
        <el-row v-if="itemName!=='home'">
            <el-col :span="24" style="margin-top:10px;margin-left:10px;">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item v-for="(item,index) in  barList" :key='item.value'>
                            <a :href='item.value' v-if="index!==0 && itemName!==item.value">{{item.name}}</a>
                            <span v-else>{{item.name}}</span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <router-view />
    </div>
</template>

<script>
import menu from "@/config/menu";

export default {
    name: "pro_content",
    data(){
        return{
            itemName:"",
            barList:[]
        }
    },
    watch: {
        //监听路由变化
        $route(newRoute) {
            if (newRoute.meta.parent) {
                this.itemName = newRoute.name;
            } else {
                this.itemName = newRoute.meta.parentName;
            }
            this.rePush();
        }
    },
    created(){
        this.itemName=this.$route.name
        this.rePush();
    },
    methods:{
        rePush(){
            this.barList=[];
            let matched=this.$route.matched;
            for(let i=1;i<matched.length;i++){
                if(matched[i].name=="home"){
                    continue;
                }
                let arr={
                    name:matched[i].meta.name,
                    value:matched[i].name
                }
                this.barList.push(arr);
            }
        }
    }

};
</script>

<style lang="less" scoped>
.content {
    height: calc(100% - 60px);
    width: calc(100% - 105px);
    margin-left: 5px;
    float: left;
    margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/main/components/content.vue